module.exports = __webpack_public_path__ + "assets/img/bg-prize-2.c6919076.png";